module.exports = __webpack_public_path__ + "img/soluciones_logisticas_en_construccion.13013212.png";